import _ from 'lodash';

const asyncCallbacksMiddleware = () => next => action => {
  if (_.isFunction(action.asyncCallback)) {
    _.defer(() => action.asyncCallback());
  }

  return next(action);
};

export default asyncCallbacksMiddleware;
